import styled from '@emotion/styled'
import React from 'react'

type rangeProps = {
  bg: string
}

export const Range = styled.input<rangeProps>`
position:relative;
width:100% !important;
z-index:1;
& {
    background-image: ${props => props.bg};
    border-radius: 0px;
    height: 19px !important;
    width: 100%;
    outline: none;
    -webkit-appearance: none
  }
      &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 8px; /* Adjust size */
    height: 19px; /* Adjust size */
    background:white; /* Change cursor (thumb) color */
    border-radius: 0%;
    cursor: pointer;
    border:1px solid var(--lightGray)
  }

`